import { render, staticRenderFns } from "./CustomizeHomepage.vue?vue&type=template&id=7bb1b244&scoped=true&"
import script from "./CustomizeHomepage.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomizeHomepage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomizeHomepage.vue?vue&type=style&index=0&id=7bb1b244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1b244",
  null
  
)

export default component.exports